import { Box, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import ReportStatusTimeline, { TimelineEvent } from './ReportStatusTimeline';
import ReportActions from './ReportActions';
import ReportInformation, { ReportInfoItem } from './ReportInformation';

interface ReportSidebarProps {
  timelineEvents: TimelineEvent[];
  canManage: boolean;
  onEdit: () => void;
  onDownload: () => void;
  isDownloading: boolean;
  onDownloadAttachments: () => void;
  isDownloadingAttachments: boolean;
  hasAttachments: boolean;
  onDelete: () => void;
  infoItems: ReportInfoItem[];
}

export default function ReportSidebar({
  timelineEvents,
  canManage,
  onEdit,
  onDownload,
  isDownloading,
  onDownloadAttachments,
  isDownloadingAttachments,
  hasAttachments,
  onDelete,
  infoItems,
}: ReportSidebarProps) {
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)'
  );

  return (
    <VStack align="stretch" spacing={4} w={{ base: '100%', lg: '320px' }} flexShrink={0}>
      <Card boxShadow={shadow}>
        <Text fontSize="md" fontWeight="bold" mb={4}>
          Azioni
        </Text>
        <ReportActions
          canManage={canManage}
          onEdit={onEdit}
          onDownload={onDownload}
          isDownloading={isDownloading}
          onDownloadAttachments={onDownloadAttachments}
          isDownloadingAttachments={isDownloadingAttachments}
          hasAttachments={hasAttachments}
          onDelete={onDelete}
        />
      </Card>

      <Card boxShadow={shadow}>
        <Box>
          <Text fontSize="md" fontWeight="bold" mb={4}>
            Informazioni
          </Text>
          <ReportInformation items={infoItems} />
        </Box>
      </Card>

      <Card boxShadow={shadow}>
        <Text fontSize="md" fontWeight="bold" mb={4}>
          Stato del rapporto
        </Text>
        <ReportStatusTimeline events={timelineEvents} />
      </Card>
    </VStack>
  );
}
